import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Global } from '@emotion/react';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import './utils/lang/i18n.config';
import global from './GlobalStyle';
import store from 'store/store';
import App from './App';

export const persistor = persistStore(store);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Global styles={global} />
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
